import { PASSCODE_RESPONSES } from '@/constants';
import { ENV } from '@/environment';

const api = {
  request: ({ method = 'POST', path, body }) => {
    return fetch(`${ENV.API_ROOT}${path}`, {
      method,
      body: body ? JSON.stringify(body) : null,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(r => r.json());
  },
  validateTutorialPassword({ id, code, sku }) {
    return this.request({
      path: '/api/verify',
      body: { id, code, kit: id, sku },
    })
      .then(r => ({
        ...r,
        id,
        code,
        message: PASSCODE_RESPONSES[r.message],
        messageKey: r.message,
      }))
      .catch(() => ({
        message: 'Oops... something went wrong. Please try again later.',
      }));
  },
  revalidateTutorialPassword({ code }) {
    return this.request({
      path: `/api/registration_codes/${code}/is_valid`,
      method: 'GET',
    }).catch(() => false);
  },
  createTicket({ name, email, source, order, meta, message, userFiles }) {
    const body = new FormData();

    body.append(
      'payload',
      JSON.stringify({
        subject: `Yarn-mergency for ${meta.tutorialName}`,
        meta,
        messages: [
          {
            from_agent: false,
            body_html: `
        <p><b>Name: </b>${name}</p>
        <p><b>Source: </b>${source}</p>
        <p><b>Order/Serial #: </b>${order}</p>
        <p><b>Kit/Section/Step: </b>${meta.path}</p>
        <p><b>Message:</b></p>
        <p>${message}</p>
        `,
            channel: 'api',
            sender: {
              email,
            },
            via: 'api',
          },
        ],
      }),
    );

    userFiles.forEach((f, i) => {
      body.append(`file${i}`, f);
    });

    return fetch(`${ENV.API_ROOT}/api/gorgias/tickets`, {
      method: 'POST',
      body,
    }).then(r => r.json());
  },
  validateMagicLink({ token }) {
    return this.request({
      path: `/api/verify_token/${token}`,
      method: 'GET',
    }).catch(() => false);
  },
};

export default api;
